import { render, staticRenderFns } from "./arearSelect.vue?vue&type=template&id=ecc5bd28&scoped=true"
import script from "./arearSelect.vue?vue&type=script&lang=js"
export * from "./arearSelect.vue?vue&type=script&lang=js"
import style0 from "./arearSelect.vue?vue&type=style&index=0&id=ecc5bd28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc5bd28",
  null
  
)

export default component.exports